/**
 * @overview 标签新增编辑页面
 * @author Ariel
 * @date 2023-08-03
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from '../../../common'

import LabelRule from '../rule/rule';
import LabelFeatureContent from '../featureContent/featureContent'

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool;
let { WizForm, WizButton, WizRow, WizCol, WizSpin, WizCustomSteps, WizNotice, Wizmessage, WizTooltip, WizIcon } = component_tool;
let { Session } = utils_tool;

const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 18 } })


const steps = [
  {
    title: '基本信息',
    content: 'First-content',
  },
  {
    title: '标签规则',
    content: 'Second-content',
  },
  {
    title: '推荐内容',
    content: 'Last-content',
  },
];

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/biz/label/update') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = 'update'
        Session.set('labelDetailUpd', record)
      } else {
        record = Session.get('labelDetailUpd') || {}
      }
    }
    if (history.location.pathname === '/biz/label/add') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = 'create'
        Session.set('labelDetailAdd', record)
      } else {
        record = Session.get('labelDetailAdd') || {}
      }
    }
  }
  return record
}

class LabelDetail extends WizContainer {

  componentName = 'labelDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let record = getParamRecord(history)
    this.state = {
      current: 0,
      key: 'labelDetail_' + new Date().getTime(),
      labelId: record.id || '',
    }
    this.nextStepState = false;
    this.initialValue = record
    this.resetTime = new Date().getTime()
    this.clearWizCallBack = [];
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/biz/label/update') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('labelDetailUpd', initialValue)
      } else {
        initialValue = Session.get('labelDetailUpd') || {};
      }
    }
    if (history.location && history.location.pathname === '/biz/label/add') {
      if (history.location.record) {
        initialValue = history.location.record
        Session.set('labelDetailAdd', initialValue)
      } else {
        initialValue = Session.get('labelDetailAdd') || {}
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({ labelId: initialValue.id })
    }
  }
  propsAndStateOnChange = {
    addLabel: this._stepOne.bind(this),
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addLabel.code == 1) {
      this.initialValue = nextProps.addLabel.data
      WizNotice.success('保存成功');
      if (this.nextStepState) {
        Session.set('labelDetailAdd', this.initialValue)
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.labelId = nextProps.addLabel.data.id
      } else {
        this.jumpPage('replaceAndDelCrumb', '/biz/label');
      }
    } else {
      this.nextStepState = false;
      WizNotice.error('保存失败：' + nextProps.addLabel.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**保存标签信息 */
  _saveLabel(values) {
    let { record } = this.props && this.props.location
    let { channelType } = this.initialValue
    let apiPath = 'label/add';
    if (this.state.labelId || channelType === "update") {
      apiPath = 'label/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addLabel',
        apiParams: {
          ...fitterValues,
        }
      }
    });

  }

  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
            onClick={e => this.nextStep()}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  /**根据步骤展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      return <WizForm className={'form-inline'} {...formProps} />
    } else if (this.state.current == 1) {
      return <LabelRule
        labelId={this.state.labelId}
        nextFunc={() => this.setState({ current: this.state.current + 1 })}
        backFunc={() => this.jumpPage('replaceAndDelCrumb', '/biz/label')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else if (this.state.current == 2) {
      return <LabelFeatureContent
        labelId={this.state.labelId}
        initialValue={this.initialValue}
        nextFunc={() => this.jumpPage('replace', '/biz/label')}
        prevFunc={() => this.setState({ current: this.state.current - 1 })}
      />
    } else {
      return null;
    }
  }

  onReset = e => {
    let ref = this.refs.form
    if (ref) {
      ref.resetFields()
    }

    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _render() {
    const { labelLoading } = this.props;
    let initialValue = this.initialValue;
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '标签名称',
        name: 'name',
        formItem: {
          maxLength: 40,
          placeholder: '标签名称最多输入40个字',
          rules: [
            {
              required: true,
              message: '请输入标签名称',
            },
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: '标签编码',
        name: 'code',
        formItem: {
          maxLength: 35,
          placeholder: '标签编码最多输入35个字',
          rules: [
            {
              required: true,
              message: '请输入标签编码',
            },
          ],
          initialValue: this.initialValue.code
        }
      },
      {
        title: '标签分类',
        name: 'categoryId',
        formItem: {
          rules: [{
            required: true,
            message: '请选择标签分类',
          }],
          ...categoryConfig,
          diy: WizTableForm,
          initialValue: initialValue?.categoryId,
          initRows: [{ ...initialValue, id: initialValue?.categoryId, name: initialValue?.categoryName }],
          selectType: 'radio',
          onClearWiz:this._onClearWiz.bind(this),
        }
      },
      {
        title: '标签描述',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '请输入，最多100字',
          maxLength: 100,
          initialValue: this.initialValue.intro
        },
      },
      {
        title: '标签状态',
        name: 'state',
        dataIndex: 'state',
        formItem: {
          type: 'select',
          initialValue: this.initialValue.id ? this.initialValue.state : 1
        },
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' },
        ]
      },
      {
        title: '是否撕除标签',
        name: 'tear',
        dataIndex: 'tear',
        formItem: {
          type: 'select',
          initialValue: this.initialValue.tear ? this.initialValue.tear : 0
        },
        dict: [
          { code: 0, codeName: '否' },
          { code: 1, codeName: '是' },
        ]
      },
      {
        name: 'source',
        dataIndex: 'source',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.source ? this.initialValue.source : 0
        },
      }
    ]

    let onSubmit = this._saveLabel.bind(this);
    let formProps = {
      ref: 'form',
      key: this.state.labelId || '', // ⭐如缓存路由需要刷新,必须加标识key
      loading: labelLoading,
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 15 }
      }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }

    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  _onReset() {
    this.onReset()
  }
}

const mapStateToProps = (state, ownProps) => {
  const { label } = state;
  const addLabel = modelUtils.getModelEntity(label, 'addLabel');
  const load = modelUtils.getLoadingState(state, ['label']);
  return {
    addLabel: addLabel,
    ...load
  }
};

export default connect(mapStateToProps)(LabelDetail);
